import Vue from "vue";
import VueI18n from "vue-i18n";

import ZH_TW from "../locales/zh_tw";
import EN from "../locales/en";
import JA from "../locales/ja";

Vue.use(VueI18n);

export default new VueI18n({
  locale: navigator.language.substring(0,2),
  fallbackLocale: "en",
  messages: {
    zh: ZH_TW,
    en: EN,
    ja: JA,
  },
  silentTranslationWarn: "all",
});
